import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as DOMPurify from 'dompurify'; // works with older TS versions

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(private readonly sanitizer: DomSanitizer) { }
    transform(url: string): SafeHtml {
        const clean = DOMPurify.sanitize(url);
        return this.sanitizer.bypassSecurityTrustResourceUrl(clean);
    }
}
